// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgImageIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-5 14H4l5.5-7 3.71 4.72L15.25 13 19 18zm3-8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2" />
  </g>
);
export default SvgImageIcon;
SvgImageIcon.displayName = 'SvgImageIcon';
